import React, { Component } from "react";
import { injectStripe } from "react-stripe-elements";
import { CardElement } from "react-stripe-elements";
import { FormControl, Button, InputGroup, Glyphicon } from "react-bootstrap";

class CardPaymentMethod extends Component {
  render() {
    return (
      <div>
        <form onSubmit={event => this.props.handleSubmitNewCard(event, this)}>
          <div className="card-holder-field">
            <InputGroup>
              <InputGroup.Addon>
                <Glyphicon glyph="user" />
              </InputGroup.Addon>
              <FormControl
                className="card-holder-name"
                bsSize="sm"
                type="text"
                name="holderName"
                required="true"
                placeholder="Cardholder name"
              />
            </InputGroup>
          </div>

          <CardElement elementRef={c => (this._element = c)} />

          <Button bsStyle="warning" type="submit">
            Save
          </Button>
        </form>
      </div>
    );
  }
}

export default injectStripe(CardPaymentMethod);



// WEBPACK FOOTER //
// ./src/home/components/card-payment-method.js